import { SalesRepresentativesAutocompleteItem } from '../../orders/types/salesRepresentativesAutocomplete.types';
import { OfflineDatabaseSalesRepresentative } from '../database/offlineDatabase/types/offlineDatabaseSalesRepresentative.types';

export class OfflineSalesRepresentativeTransformers {
  static toSalesRepresentative(
    salesRep: OfflineDatabaseSalesRepresentative,
  ): SalesRepresentativesAutocompleteItem {
    return {
      active: true,
      id: salesRep.id,
      code: salesRep.code,
      name: salesRep.name,
      description: '',
    };
  }
}
